import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { WebRouletteStatus } from 'app/core/model/web-roulette-status';
import { Roulette } from 'app/public/model/roulette.model';
import { StripePaymentsService } from 'app/public/services/stripe-payments.service';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { StripeService } from 'ngx-stripe';
import { catchError } from 'rxjs/operators';
import { FieldDialogComponent } from '../field-dialog/field-dialog.component';
import { CustomerFieldDTO } from 'app/public/model/CustomerFieldDto';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { CommonService } from 'app/shared/services/common.service';
import { tap } from 'rxjs/operators';
import { Platforms, SourceEnum } from 'app/shared/model/enums';
import { SendByType } from 'app/public/model/send-by-type.model';

@Component({
  selector: 'app-roulette-general-details',
  templateUrl: './roulette-general-details.component.html',
  styleUrls: ['./roulette-general-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteGeneralDetailsComponent implements OnInit {
  @Input()
  roulette: Roulette;

  @Input() form: NgForm;
  @ViewChild(FieldDialogComponent) fieldDialog: FieldDialogComponent;

  expireDaysOptions = [7, 14, 30, 45, 60, 90, 120, 360];
  sendByTypes: SendByType[] = [];

  public get rouletteDetails() {
    return this.roulette?.GeneralDetails;
  };

  constructor(private messageService: AdvMessageService,
    private commonService: CommonService,
    private localizationService: LocalizationService, private subscriptionService: SubscriptionService,
    private cdr: ChangeDetectorRef, private stripePaymentsService: StripePaymentsService, private webRouletteService: WebRouletteService,
    private stripeService: StripeService) { }
  displayDialog = false;
  showSendCampaignDialog = false;
  roulettesNames: { label: string, value: number }[] = [];
  selectedRouletteForSend: number = null;

  ngOnInit(): void {
    this.loadSendByTypes();
  }

  loadSendByTypes(): void {
    this.webRouletteService.getSendByTypes().subscribe(types => {
      this.sendByTypes = types;
      this.cdr.markForCheck();
    });
  }

  getSelectedSendMethodsText(): string {
    if (!this.roulette?.SendCouponBy || this.roulette.SendCouponBy.length === 0) {
      return '';
    }
    
    const selectedNames = this.sendByTypes
      .filter(type => this.roulette.SendCouponBy.includes(type.Id))
      .map(type => {
        // Translate the description to Hebrew
        const translationKey = `ROULETTE.${type.Description.toUpperCase()}`;
        return this.localizationService.Translate(translationKey);
      });
    
    return selectedNames.join(', ');
  }

  public get showAutoRenwal(): boolean {
    return (
      this.roulette?.GeneralDetails?.Id != null &&
      this.roulette?.GeneralDetails?.PackageType != null &&
      this.roulette?.GeneralDetails?.PackageType !== 3 &&  // 3 = WebFrontal
      !this.roulette?.GeneralDetails?.IsAllowToSendCampain
    );
  }


  public getRouletteTypeText(): string {
    const packageType = this.roulette?.GeneralDetails?.PackageType;
    if (packageType === 3) {
      return 'ROULETTE.FRONTAL_ROULETTE';
    }
    return 'ROULETTE.WEB_ROULETTE';
  }
  get isAvailable() {
    return this.roulette && (this.roulette.GeneralDetails.Status == WebRouletteStatus.purched ||
      this.roulette.GeneralDetails.Status == WebRouletteStatus.purchedFreePackage ||
      this.roulette.GeneralDetails.Status == WebRouletteStatus.purchedNotLimitPackage);
  }
  changeAutoRenewal(event) {
    switch (this.roulette.GeneralDetails.Status) {
      case WebRouletteStatus.expired:
      case WebRouletteStatus.notPurched:
      case WebRouletteStatus.purchedNotLimitPackage:
      case WebRouletteStatus.purchedFreePackage:
      case WebRouletteStatus.spinsLimitForFreePackage:
        //do nothing
        break;
      default:
        this.changeRenewalPackage(event.checked);

    }
  }
  changeRenewalPackage(renewal: boolean) {
    const confirmMsg = renewal ? 'ROULETTE.CHANGE_RENEWAL_MSG' : 'ROULETTE.CHANGE_NOT_RENEWAL_MSG';

    this.messageService.showConfirmation(this.localizationService.Translate("ROULETTE.CHANGE_RENEWAL_TITLE"),
      this.localizationService.Translate(confirmMsg), (ok) => {
        this.buyRenewalPackage(renewal);
      }
      ,
      (cancel) => {
        this.cancelAutoRenewalChange(renewal);
      });
  }

  buyRenewalPackage(renewal: boolean) {
    if (!renewal) {
      this.doChangeRenewalPackage(renewal);
    } else {
      this.stripePaymentsService.businessHasMethodPayment()
        .pipe(catchError((error) => {
          this.cancelAutoRenewalChange(renewal);
          throw error;
        }))
        .subscribe((hasMethodPayment: Boolean) => {
          if (hasMethodPayment) {
            this.doChangeRenewalPackage(renewal);
          } else {
            this.subscriptionService.createStripeSessionForAutoRenewal(this.roulette.GeneralDetails.Id, `${window.location.origin}/webplatform/payment-success`, `${window.location.origin}/webplatform/payment-failed`)
              .pipe(catchError((error) => {
                this.cancelAutoRenewalChange(renewal);
                throw error;
              }))
              .subscribe((response: any) => {
                this.stripeService.redirectToCheckout({
                  sessionId: response.SessionId,
                }).subscribe(data => {
                });
              });
          }
        });
    }
  }

  cancelAutoRenewalChange(renewal: boolean) {
    this.roulette.GeneralDetails.AutoRenewalPackage = !renewal;
    this.cdr.markForCheck();
  }
  doChangeRenewalPackage(renewal: boolean) {
    const successMsg = renewal ? 'ROULETTE.CHANGE_RENEWAL_SUCCESS' : 'ROULETTE.CHANGE_NOT_RENEWAL_SUCCESS';
    this.subscriptionService.changeRenewalPackage(this.roulette.GeneralDetails.Id, renewal)
      .pipe(catchError((error) => {
        this.cancelAutoRenewalChange(renewal);
        throw error;
      })).subscribe(() =>
        this.messageService.successMessage(this.localizationService.Translate(successMsg)
        ));
  }

  public get showCancelSubscription(): boolean {
    const details = this.roulette?.GeneralDetails;
    if (!details?.Id) return false;
    const isFrontal = details.PackageType === 3;
    const hasActivePaidPackage = details.Status === WebRouletteStatus.purched ||
      details.Status === WebRouletteStatus.purchedNotLimitPackage ||
      details.Status === WebRouletteStatus.purchedButNotAvailable;
    // Allow cancel only for frontal (not auto-renewal) for customers
    return isFrontal && (hasActivePaidPackage || details.IsSubscriptionCanceled === true);
  }

  cancelSubscription() {
    this.messageService.showConfirmation(
      this.localizationService.Translate('ROULETTE.CANCEL_SUBSCRIPTION_TITLE'),
      this.localizationService.Translate('ROULETTE.CANCEL_SUBSCRIPTION_MSG'),
      () => {
        this.subscriptionService.cancelRouletteSubscription(this.roulette.GeneralDetails.Id)
          .pipe(catchError((error) => { throw error; }))
          .subscribe(() => {
            this.roulette.GeneralDetails.AutoRenewalPackage = false;
            this.roulette.GeneralDetails.IsSubscriptionCanceled = true;
            this.cdr.markForCheck();
            this.messageService.successMessage(this.localizationService.Translate('ROULETTE.CANCEL_SUBSCRIPTION_SUCCESS'));
          });
      }
    );
  }
  showDialog() {
    this.displayDialog = true;
  }

  closeDialog() {
    this.displayDialog = false;
  }

  onFieldsUpdated(updatedFields: CustomerFieldDTO[]) {
    this.roulette.AdditionalCustomerFields = updatedFields;
    if (updatedFields.length > 0 && this.roulette.GeneralDetails.Id > 0) {
      this.commonService.blockScreen(true);

      this.webRouletteService.saveCustomerFields({
        RouletteId: this.roulette.GeneralDetails.Id,
        fields: updatedFields
      })
        .pipe(
          tap(() => {
            this.commonService.blockScreen(false);
          })
        )
        .subscribe({
          next: () => {
            this.messageService.successMessage('GENERAL.MESSAGES.SAVED_SUCCESSFULY', true);
          },
          error: (err) => {
            this.commonService.blockScreen(false);
            this.messageService.errorMessage('ERRORS.SAVE_FAILED', false);
          }
        });
    }
  }

  loadRoulettesForSend(): void {
    this.webRouletteService.getRoulettesList(0).subscribe((res: any) => {
      if (res?.Roulettes) {
        this.roulettesNames = res.Roulettes.map(r => ({ label: r.RouletteName, value: r.RouletteId }));
        this.cdr.markForCheck();
      }
    });
  }

  openSendCampaignDialog() {
    this.selectedRouletteForSend = null;
    this.loadRoulettesForSend();
    this.showSendCampaignDialog = true;
    this.cdr.markForCheck();
  }

  onRouletteForSendChange(event: any) {
    this.selectedRouletteForSend = event?.value ?? null;
  }

  confirmSendCampaign() {
    this.showSendCampaignDialog = false;
    const filterRouletteId = this.selectedRouletteForSend ?? 0;
    this.commonService.blockScreen(true);
    this.webRouletteService.sendRouletteToLeads(this.rouletteDetails.Id, filterRouletteId).subscribe(
      (res: any) => {
        this.commonService.blockScreen(false);
        if (res?.SendRoulette === false) {
          const msg = res.ErrorMessage === 'No leads found for this roulette'
            ? this.localizationService.Translate('ROULETTE.SEND_CAMPAIGN_NO_LEADS')
            : res.ErrorMessage === 'You have already sent this roulette to your leads'
            ? this.localizationService.Translate('ROULETTE.SEND_CAMPAIGN_ALREADY_SENT')
            : res.ErrorMessage;
          this.messageService.errorMessage(msg);
        } else {
          const countOfCustomers = res?.CountOfCustomers ?? 0;
          this.messageService.successMessage(
            this.localizationService.Translate('ROULETTE.SEND_CAMPAIGN_SUCCESS', { countOfCustomers })
          );
        }
        this.cdr.markForCheck();
      },
      () => {
        this.commonService.blockScreen(false);
        this.messageService.errorMessage(this.localizationService.Translate('ROULETTE.SEND_CAMPAIGN_ERROR'));
        this.cdr.markForCheck();
      }
    );
  }

  getIframeLink(rouletteLink: string): string {
    if (!rouletteLink) return '';
    
    // Extract token from the RouletteLink (assuming format: ...?g=TOKEN or .../TOKEN)
    const urlParts = rouletteLink.split('?g=');
    const token = urlParts.length > 1 ? urlParts[1] : rouletteLink.split('/').pop();
    
    return `https://spintowinweb.azurewebsites.net?iframe=true&g=${token}`;
  }

  getFullIframeCode(rouletteLink: string): string {
    if (!rouletteLink) return '';
    
    const urlParts = rouletteLink.split('?g=');
    const token = urlParts.length > 1 ? urlParts[1] : rouletteLink.split('/').pop();
    
    return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Iframe Example</title>
<style>
body, html {
height: 100%;
padding: 2rem;
display: flex;
flex-direction: column;
}

iframe {
border: none;
width: 700px;
height: 500px;
overflow: hidden;
}

.title {
margin-bottom: 3px;
}
</style>
</head>
<body>
<b class="title">Rolleta in Iframe example: </b>
<iframe title="Spin to Win"
src="https://spintowinweb.azurewebsites.net/?iframe=true&g=${token}">
</iframe>

<script>
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://spintowinweb.azurewebsites.net') return; 
    const data = event.data;   
    if (data && data.type === 'FORM_COMPLETED') {
      const payload = data.payload || {};
      let name = payload.name;
      let email = payload.email;
      let phone = payload.phone;
      let completedAt = payload.completedAt; 
      console.log('FORM_COMPLETED received:', name, email, phone, completedAt);
    }
  });
</script>
</body>
</html>`;
  }

  downloadIframeDoc(): void {
    const link = document.createElement('a');
    link.href = 'assets/files/RoulletaInIframeReadme.docx';
    link.download = 'RoulletaInIframeReadme.docx';
    link.click();
  }
}
